var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("sticky", { attrs: { "z-index": 10 } }, [
        _c(
          "div",
          { staticClass: "mb-10 pl-10 pt-10 pr-10 bg-white l-t shadow-light" },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "filter-from text-center",
                attrs: { inline: true, size: "small" },
              },
              [
                _c(
                  "el-form-item",
                  { staticClass: "mb-10 flex1", attrs: { label: "用户ID：" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_uid,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_uid", $$v)
                        },
                        expression: "form.search_uid",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "mb-10 flex1",
                    attrs: { label: "用户昵称：" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_nick_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_nick_name", $$v)
                        },
                        expression: "form.search_nick_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "mb-10 flex1",
                    attrs: { label: "手机号码：" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_phone", $$v)
                        },
                        expression: "form.search_phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content:
                            "最多可添加" +
                            _vm.agentInfo.member_num +
                            "名免费店员",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.toQuery()
                              },
                            },
                          },
                          [
                            _vm._v("查询用户添加"),
                            _c("i", {
                              staticClass: "el-icon-search el-icon--right",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.searchStatus
                  ? _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "infou" },
                            on: {
                              click: function ($event) {
                                return _vm.toQuery(1)
                              },
                            },
                          },
                          [
                            _vm._v("取消"),
                            _c("i", {
                              staticClass: "el-icon-close el-icon--right",
                            }),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "p-10" }, [
        _vm.searchStatus
          ? _c(
              "div",
              { staticClass: "p-20 bg-white" },
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.searchList,
                      stripe: "",
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "用户ID" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "flex align-center" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(scope.row.id) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        173942726
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "用户" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "flex align-center" },
                                  [
                                    _c("el-avatar", {
                                      attrs: {
                                        size: "small",
                                        src: scope.row.avatar,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "flex1 pl-10" }, [
                                      _vm._v(
                                        _vm._s(scope.row.nick_name || "--")
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1312767662
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "手机号码" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.mobile || "--") +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2186425053
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "注册时间" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.parseTime(
                                        scope.row.add_date,
                                        "{y}-{m}-{d} {h}:{i}:{s}"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3216774648
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "100" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      plain: "",
                                      round: "",
                                      size: "small",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addUser(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("添加")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2074402719
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "p-20 bg-white" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading",
                      },
                    ],
                    attrs: {
                      id: "order_table",
                      data: _vm.list,
                      "element-loading-text": "Loading",
                      stripe: "",
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "用户" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "flex align-center" },
                                [
                                  _c("el-avatar", {
                                    attrs: {
                                      size: "small",
                                      src: scope.row.avatar,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "flex1 pl-10" }, [
                                    _vm._v(_vm._s(scope.row.nick_name || "--")),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "用户ID" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.uid || "--") +
                                  "\n            "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "手机号码" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.mobile || "--") +
                                  "\n            "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "注册时间" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.parseTime(
                                      scope.row.add_date,
                                      "{y}-{m}-{d} {h}:{i}:{s}"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "商户" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.store_name || "--") +
                                  "\n            "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "免费时长" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n\t\t      " +
                                  _vm._s(scope.row.member_free_due_hours) +
                                  "小时\n\t\t    "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "今日次数" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.member_used_count) +
                                  "/" +
                                  _vm._s(scope.row.member_day_count) +
                                  "\n            "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    plain: "",
                                    round: "",
                                    size: "small",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.vipDialog = true
                                      _vm.vipInfo = scope.row
                                    },
                                  },
                                },
                                [_vm._v("时长次数")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    plain: "",
                                    round: "",
                                    size: "small",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delUser(
                                        scope.row,
                                        scope.$index
                                      )
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "p-20 flex justify-center" },
                  [
                    _c("pagination", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.listQuery.page_num > 0,
                          expression: "listQuery.page_num > 0",
                        },
                      ],
                      attrs: {
                        page: _vm.listQuery.start,
                        limit: _vm.listQuery.limit,
                        "page-count": _vm.listQuery.page_num,
                      },
                      on: {
                        "update:page": function ($event) {
                          return _vm.$set(_vm.listQuery, "start", $event)
                        },
                        "update:limit": function ($event) {
                          return _vm.$set(_vm.listQuery, "limit", $event)
                        },
                        pagination: _vm.getList,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "设置时长次数", visible: _vm.vipDialog },
          on: {
            "update:visible": function ($event) {
              _vm.vipDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "140px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "免费时长：" } },
                [
                  _c(
                    "el-input",
                    {
                      model: {
                        value: _vm.vipInfo.free_due_hours,
                        callback: function ($$v) {
                          _vm.$set(_vm.vipInfo, "free_due_hours", $$v)
                        },
                        expression: "vipInfo.free_due_hours",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("小时")])],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "fs-s2 text-gray" }, [
                    _vm._v(
                      "注：免费时长不可超过" +
                        _vm._s(_vm.agentInfo.member_free_due_hours) +
                        "小时。"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "每天使用次数：" } },
                [
                  _c(
                    "el-input",
                    {
                      model: {
                        value: _vm.vipInfo.day_count,
                        callback: function ($$v) {
                          _vm.$set(_vm.vipInfo, "day_count", $$v)
                        },
                        expression: "vipInfo.day_count",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("次")])],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "fs-s2 text-gray" }, [
                    _vm._v(
                      "注：每天使用次数不可超过" +
                        _vm._s(_vm.agentInfo.member_day_count) +
                        "次。"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setDayCount()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }